import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWrench = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="m7.311 2.215 3.007 3.007c.197.197.308.465.308.744v3.607c0 .582-.471 1.053-1.053 1.053H5.966c-.28 0-.547-.111-.744-.308L2.215 7.31a6.163 6.163 0 0 0 8.709 6.725 1.05 1.05 0 0 1 1.197.205l7.216 7.215a1.499 1.499 0 1 0 2.12-2.12l-7.216-7.215a1.052 1.052 0 0 1-.205-1.197A6.164 6.164 0 0 0 7.31 2.215ZM4.911.807a8.268 8.268 0 0 1 11.318 10.326l6.716 6.716a3.603 3.603 0 1 1-5.096 5.096l-6.716-6.716A8.268 8.268 0 0 1 .807 4.911a1.052 1.052 0 0 1 1.694-.29l3.9 3.9h2.12v-2.12l-3.9-3.9A1.052 1.052 0 0 1 4.91.807Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWrench);
export default ForwardRef;
